import $ from 'jquery';
import { runProtectedRoute } from '../middleware';
import { router } from '~src/router';
import { openCanvasById } from '~loader';
import { showSpinner, getMetadata, hideSpinner } from '~loader/loader-utils';
import { modifyState } from '~src/state';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';

export const canvasRoute = async ({ data }) => {
  // Show canvas + spinner immediately so the user gets visual feedback
  // even before slow middleware (auth, analytics, org checks) completes —
  // commonMiddleware later calls `.editor-route.hide()` which we restore.
  $('.editor-route').not('#route-canvas').hide();
  $('#route-canvas').show();
  showSpinner();

  const ready = await runProtectedRoute();
  if (!ready) return;

  $('#route-canvas').show();
  showSpinner();

  if (!data || !data.id) {
    return router.navigate('/start');
  }

  $('body').addClass('canvas-route');

  $('#navbar-private').hide();
  $('#navbar-canvas').show();

  modifyState('editorMode', EDITOR_MODE_DEFAULT);
  await openCanvasById(data.id);

  const metadata = getMetadata();
  document.title =
    [
      metadata.projectTypeName,
      metadata.templatesCategoryName,
      metadata.formatName,
      metadata.servizioName,
    ].join(' ') + ' | Giotto';

  hideSpinner();
};
